import { Fragment, FunctionComponent, h } from 'preact'
import { RoutableProps } from 'preact-router'

export const Contact: FunctionComponent<RoutableProps> = () => {
  return (
    <Fragment>
      <section className="section">
        <div className="section-title">Contact</div>
        <p>
          <pre>ieee.hiroshima.ssb(at)gmail.com</pre>
        </p>
      </section>
    </Fragment>
  )
}
